import { FormlySelectOption } from '@ngx-formly/core/select';
import { COUNTRIES } from '@core/data-access';

const reorderCountriesByIsoCode = (
  countries: [string, string, string, number?, string[]?][],
  priorityIsoCodes: string[],
): [string, string, string, number?, string[]?][] => {
  // Create a map of ISO codes with their desired order (index as priority)
  const priorityMap = new Map<string, number>();
  priorityIsoCodes.forEach((isoCode, index) => {
    priorityMap.set(isoCode, index);
  });

  // Split countries into priority and non-priority lists
  const priorityList: [string, string, string, number?, string[]?][] = [];
  const otherList: [string, string, string, number?, string[]?][] = [];

  countries.forEach(country => {
    const isoCode = country[1]; // ISO code is the second element
    if (priorityMap.has(isoCode)) {
      priorityList.push(country);
    } else {
      otherList.push(country);
    }
  });

  // Sort priority list based on the order in priorityIsoCodes
  priorityList.sort((a, b) => {
    const aIndex = priorityMap.get(a[1]) ?? Infinity; // Fallback to Infinity if not found
    const bIndex = priorityMap.get(b[1]) ?? Infinity;
    return aIndex - bIndex;
  });

  // Return combined list: priority countries followed by others
  return [...priorityList, ...otherList];
};

// Reorder the COUNTRIES array using ISO codes
const priorityIsoCodes = ['sg', 'my', 'id', 'th', 'kh', 'ph'];

const REORDERED_COUNTRIES = reorderCountriesByIsoCode(COUNTRIES, priorityIsoCodes);

export const DialCodeOptions = REORDERED_COUNTRIES.map<FormlySelectOption>(([name, isoCode, dialCode]) => {
  return { value: `${dialCode}`, label: `${name} (+${dialCode})` };
});
